// extracted by mini-css-extract-plugin
module.exports = {"storyblok-expert-page-hero-picture__image":"StoryblokExpertPageHeroPicture_storyblok-expert-page-hero-picture__image__MThsG"};